import React from 'react'
import {Box, Typography} from '@mui/material'
import AppDialog from 'src/components-new/feedback/AppDialog'
import {SecondaryTherapyItem} from 'src/pages-new/homepage/types'
import {formatItemDate, getDosageRows} from 'src/pages-new/homepage/utils'

interface TherapyReminderDialogProps {
  open: boolean
  onClose: () => void
  therapy: SecondaryTherapyItem | null
}

const ROW_LABEL_SX = {fontSize: 12, color: 'text.secondary', mb: 0.25}
const ROW_VALUE_SX = {fontSize: 14, fontWeight: 500}

export default function TherapyReminderDialog({open, onClose, therapy}: TherapyReminderDialogProps) {
  const dosageRows = therapy ? getDosageRows(therapy) : []
  return (
    <AppDialog
      open={open}
      onClose={onClose}
      title='Dettaglio terapia accessoria'
      maxWidth='xs'
    >
      {therapy && (
        <Box sx={{display: 'flex', flexDirection: 'column', gap: 2, pt: 1}}>
          <Box sx={{width: '100%', display: 'flex', flexDirection: 'column', gap: 1.5}}>
            <Box>
              <Typography sx={ROW_LABEL_SX}>Farmaco</Typography>
              <Typography sx={ROW_VALUE_SX}>{therapy.drug?.name ?? '—'}</Typography>
            </Box>
            {dosageRows.map(row => (
              <Box key={row.label}>
                <Typography sx={ROW_LABEL_SX}>{row.label}</Typography>
                <Typography sx={ROW_VALUE_SX}>{row.value}</Typography>
              </Box>
            ))}
            {therapy.startDate && (
              <Box>
                <Typography sx={ROW_LABEL_SX}>Data inizio</Typography>
                <Typography sx={ROW_VALUE_SX}>{formatItemDate(therapy.startDate)}</Typography>
              </Box>
            )}
            {therapy.endDate && (
              <Box>
                <Typography sx={ROW_LABEL_SX}>Data fine</Typography>
                <Typography sx={ROW_VALUE_SX}>{formatItemDate(therapy.endDate)}</Typography>
              </Box>
            )}
          </Box>
        </Box>
      )}
    </AppDialog>
  )
}
